import ElectronIPC from '../../services/ElectronIPC'
import * as Constants from '../../services/Constants'
import { CircleIconButton } from '../../UIComponents2/CircleIconButton'
import DiscordIcon from '../../CustomIcons/DiscordIcon'

export function DiscordButton({ className }: { className?: string }) {
    const onDiscordClick = () => {
        ElectronIPC.openLinkInBrowser(Constants.links.discord_invite_link)
    }

    return (
        <CircleIconButton className={className} onClick={onDiscordClick}>
            <DiscordIcon style={{ fontSize: '1.3rem' }} />
        </CircleIconButton>
    )
}
